import { AbstractTableHeadingButton } from "../../AbstractTableHeadingButton";
import { EnabledInTableHeaderValues } from "../../customTools/EnabledInTableHeader";

export class DetailDropdownButton extends AbstractTableHeadingButton {
    override create() {
        super.create();
        this.button.setProps({
            id: `${this.table.id}-tools-buttonDetailDropdown`,
            enabledInTableHeader: EnabledInTableHeaderValues.ONE_ROW_SELECTED,
            padding: 8,
            borderWidth: 0,
            margin: 0,
            paddingLeft: 0,
            marginLeft: 0,
            paddingRight: 2,
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
            // Presence of contextMenuItems causes button to render the down arrow
            contextMenuItems: () => this.table.crudManager.getOpenContextMenuItems(this.table.selectedRow,
                [ this.table.crudManager.defaultOpenType ]),
            tooltip: "Show other options for drilling down to the selected row in this table"
        });
    }
}
